<template>
  <CalicoOnboarding
    :loading="loading"
    :footer="false"
  >
    <div class="choose-account-container">
      <div class="banner">
        <CalicoBanner
          fixed
          variant="success"
          @close="show2 = false"
        >
          <p class="body--medium">
            Your email has been successfully verified.
          </p>
        </CalicoBanner>
      </div>
      <div class="content-container">
        <div class="text-section">
          <div class="title display--small">
            Welcome to BetaScore!
          </div>
          <div class="subtitle body--large">
            Choose the profile that best suited for your needs:
          </div>
        </div>

        <div class="selection-container">
          <div
            v-for="(option, index) in accountOptions"
            :key="index"
            class="card"
          >
            <div class="card-content">
              <div class="icon-title-container">
                <i :class="['contained-icon-large', option.icon]" />
                <h3 class="heading--xsmall">
                  {{ option.title }}
                </h3>
              </div>
              <p class="body--medium">
                {{ option.description }}
                <span
                  v-if="index === 1"
                  class="line-break"
                />
                <span
                  class="underlined"
                  :class="[{ 'eligibility-danger': index === 1 }]"
                >{{ option.eligibility }}</span>
              </p>
            </div>
            <div
              class="card-actions"
              :class="[
                'card-actions--margin',
                { 'card-actions--margin-31': index === 1 },
              ]"
            >
              <button
                class="button-primary"
                @click="handleSelection(option)"
              >
                {{ option.primaryButtonText }}
              </button>
              <button
                v-if="index === 0"
                class="button-tertiary-icon--small label--medium"
              >
                <a
                  href="https://www.betascore.ai/small-businesses"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link"
                >
                  {{ option.secondaryButtonText }}
                </a>
                <i class="bi bi-arrow-up-right" />
              </button>

              <button
                v-if="index === 1"
                class="button-tertiary-icon--small label--medium"
              >
                <a
                  href="https://www.betascore.ai/lending-institutions"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="link"
                >
                  {{ option.secondaryButtonText }}
                </a>
                <i class="bi bi-arrow-up-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CalicoOnboarding>
</template>

<script>
import CalicoBanner from "@/components/calico/banner/index.vue";
import CalicoOnboarding from "@/components/template/onboarding/index.vue";
import services from "@/services";

export default {
  name: "ChooseAccountTypeScreen",
  components: {
    CalicoBanner,
    CalicoOnboarding,
  },
  data() {
    return {
      progresses: [],
      accountOptions: [{
          title: "Business Owner",
          description:
            "Create a profile for your business and generate a BetaScore.",
          eligibility:
            "Must be an individual with 25% or more equity, or an authorized administrator.",
          icon: "bi bi-shop",
          primaryButtonText: "Select Business",
          secondaryButtonText: "Learn More",
        }, {
          title: "Evaluator",
          description:
            "Search and view the financial health profiles of businesses in the U.S.",
          eligibility: "This account cannot generate a BetaScore.",
          icon: "bi bi-people",
          primaryButtonText: "Select Evaluator",
          secondaryButtonText: "Learn More",
        }],
      loading: true
    }
  },
  async mounted() {
    this.progresses = await services.progress.get()
    this.loading = false
  },
  methods: {
    async handleSelection (option) {
      this.loading = true
      services.progress.complete(1)
      if (option.title === "Business Owner") {
        await services.role.put(2)
        await this.$router.push("/kyb/claim-business");
      } else if (option.title === "Evaluator") {
        await services.role.put(4)
        await this.$router.push("/access-code");
      }
      this.loading = false
    }
  }
};
</script>

<style scoped lang="scss">
.choose-account-container {
  @include stack-space($space-none);
  align-items: center;
  background-color: $color-background-secondary;
  padding-bottom: 128px;
  padding-inline: $space-large;
  .banner {
    @include inset-space($space-large);
    max-width: $tablet-breakpoint-min-width;
    width: 100%;
    @include inline-space($space-none);
    align-items: center;
    justify-content: center;
  }

  .content-container {
    @include stack-space($space-xlarge);
  }

  .text-section {
    @include stack-space($space-medium);
    align-items: flex-start;
    text-align: center;
    @media (max-width: $mobile-breakpoint-max-width) {
      @include stack-space($space-large);
      align-items: flex-start;
      text-align: start;

    }
  }

  .selection-container {
    @include inline-space($space-large);
    max-width: $tablet-breakpoint-min-width;
    width: 100%;
    @media (max-width: $mobile-breakpoint-max-width) {
      @include stack-space($space-large);
      justify-content: center;
      align-items: center;
    }
  }

  .card {
    @include stack-space($space-none);
    align-items: center;
    background-color: transparent;
    padding: $space-large;
    border: 1px solid $color-black;
    border-radius: $radius-large;
    width: 100%;
    @media (max-width: $mobile-breakpoint-max-width) {
     width: 90%;
    }
  }

  .card-content {
    @include stack-space($space-small);
    align-items: flex-start;
  }

  .icon-title-container {
    @include stack-space($space-small);
    align-items: flex-start;

    h3 {
      margin: 0;
    }
  }

  p {
    margin: 0;
  }

  .bi-people {
    background-color: $color-cyan;
    border-color: $color-cyan;
  }

  .underlined {
    text-decoration: underline;
  }

  .eligibility-danger {
    color: $color-red-dark;
    text-decoration: none;
  }

  .card-actions {
    @include stack-space($space-medium);
    align-items: center;
    width: 100%;

    .button-tertiary-icon--small {
      color: $color-black;
      &:hover {
        width: fit-content;
      }
    }
  }

  .card-actions--margin {
    margin-top: 56px;
  }

  .card-actions--margin-31 {
    margin-top: 31px;
  }

  .line-break {
    display: block;
    margin: $space-large $space-none;
  }

  .link {
    text-decoration: none;
    color: inherit;
  }
}
</style>